module.exports = __webpack_public_path__ + "img/ge-ab.35714e54.svg";